import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';

import useComicPosts from 'hooks/useComicPosts';
import { formatDate } from 'utils/date';

import RichTextContent from 'components/RichTextContent/RichTextContent';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import './SingleComic.scss';
import { routes } from '../../routing/routes';

const getSecondaryHeader = (publishDate: Date) => {
  let secondaryHeader = `Published ${formatDate(publishDate)}`;
  return secondaryHeader;
};

export default function SingleComic() {
  const { id } = useParams();
  const { isLoading, comicPost } = useComicPosts(id);

  if (isLoading || !comicPost) {
    return null;
  }

  const {
    title,
    blurb,
    imageUrl,
    publishDate,
    screenReader,
    breakers,
    nextChapter,
    previousChapter,
  } = comicPost;

  console.log(breakers);
  let i = 0;

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="media"
    >
      <Helmet>
        <title>{`${title} Webcomic - DuskBreakers`}</title>
        <meta name="description" content={blurb} />
      </Helmet>

      <section>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.comic.base()}>Comic</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {title}
                  </li>
                </ol>
              </nav>
              <h1 className="mb-3">
                <span>{title}</span>
              </h1>
              <p className="text-muted mb-5">{getSecondaryHeader(publishDate)}</p>
            </div>
          </div>
        </div>

        <div className="visually-hidden visually-hidden-focusable">
          <h3>Screenreader transcription</h3>
          <RichTextContent node={screenReader} />
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col" id="webcomic">
              <LazyLoadImage
                className="img-fluid w-100"
                alt={title}
                src={imageUrl}
                effect="opacity"
              />
            </div>
          </div>
        </div>

        <div className="container pt-4">
          <div className="row d-flex justify-content-center">
            <div className="col-6 col-lg-4">
              {previousChapter && (
                <Link
                  to={`/comic/${previousChapter.id}/${previousChapter.slug}`}
                  className="btn btn-sm d-block btn-outline-primary"
                >
                  Previous Chapter
                </Link>
              )}
            </div>
            <div className="col-4 d-none d-lg-flex align-items-center justify-content-center text-muted">
              {title}
            </div>
            <div className="col-6 col-lg-4">
              {nextChapter && (
                <Link
                  to={`/comic/${nextChapter.id}/${nextChapter.slug}`}
                  className="btn btn-sm d-block btn-outline-primary"
                >
                  Next Chapter
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="container pt-5">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-6">
              <h4 className="mb-4">About This Chapter</h4>
              <p>{blurb}</p>
            </div>
            <div className="col-lg-6">
              <h4 className="mb-4 mt-4 mt-lg-0">Featuring</h4>
              <div>
                {breakers.map((item) => {
                  return (
                    <div key={i++} className="d-flex align-items-center mb-3">
                      <Link to={'/gallery?breakerId=' + item} key={i++} className="noline">
                        <img
                          src={'https://duskbreakers.gg/breaker_thumbnails/' + item + '.jpg'}
                          alt="Breaker number {item}"
                          className="img-fluid rounded me-3 col-2"
                        />
                        <span>Breaker #{item}</span>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
